import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const inputVariants = cva(
  'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
  {
    variants: {
      size: {
        sm: 'h-7 text-sm',
        default: 'h-9',
        lg: 'h-11 text-base',
      },
      variant: {
        default: '',
        error:
          'border-destructive ring-destructive/20 focus-visible:ring-destructive/50',
        success:
          'border-green-500 ring-green-500/20 focus-visible:ring-green-500/50',
      },
    },
    defaultVariants: {
      size: 'default',
      variant: 'default',
    },
  }
)

export interface InputProps
  extends
    Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot='input'
        ref={ref}
        className={cn(inputVariants({ size, variant }), className)}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'
export { Input, inputVariants }
